import { useTheme } from "@emotion/react";
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import {
  CloseOutlined,
  NetworkPing,
  SpeedOutlined,
  TrendingDownOutlined,
} from "@mui/icons-material";
import CardGraphComponent from "../../../../../components/cardGraphComponent";
import ChartTooltip from "../chartTooltip";
import useStyles from "./styles";

export default function PingDetailModal({
  open = false,
  destino = null,
  data = {},
  loading = {},
  onClose = () => {},
  onZoom = () => {},
  formatPing = (value) => value,
  formatPacketLoss = (value) => value,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const latency = Array.isArray(data?.latency) ? data?.latency : [];
  const packetLoss = Array.isArray(data?.packetLoss) ? data?.packetLoss : [];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: styles.pingModalDialog }}
    >
      {/* cabeçalho com ícone do destino e botão fechar */}
      <Box sx={styles.pingModalHeader}>
        <Box sx={styles.pingModalHeaderIcon}>
          {typeof destino?.image === "string" ? (
            <img
              src={destino?.image}
              alt={destino?.description || "destino"}
              style={{ width: 28, height: 28, objectFit: "contain" }}
            />
          ) : (
            <NetworkPing sx={{ fontSize: 28 }} />
          )}
          <Typography sx={styles.pingModalTitle}>
            {destino?.description || ""}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseOutlined />
        </IconButton>
      </Box>

      <DialogContent sx={styles.pingModalContent}>
        {/* gráfico de latência do destino selecionado */}
        <Paper variant="outlined" sx={styles.graphPaper}>
          <CardGraphComponent
            loading={loading?.latency}
            titleGraph={`Latência — ${destino?.description || ""}`}
            data={latency}
            icon={SpeedOutlined}
            valueCard={formatPing(latency?.[latency?.length - 1]?.value || 0)}
            tickFormatter={formatPing}
            CustomTooltip={
              <ChartTooltip title="Latência" formatValue={formatPing} />
            }
            iconColorCard={
              latency?.[latency?.length - 1]?.value > 100 ? "red" : "green"
            }
            handleAplicarZoom={onZoom}
            isZoomEnabled={true}
          />
        </Paper>

        {/* gráfico de perda de pacotes do destino selecionado */}
        <Paper variant="outlined" sx={styles.graphPaper}>
          <CardGraphComponent
            loading={loading?.packetLoss}
            titleGraph={`Perda de Pacotes — ${destino?.description || ""}`}
            data={packetLoss}
            icon={TrendingDownOutlined}
            valueCard={formatPacketLoss(
              packetLoss?.[packetLoss?.length - 1]?.value || 0,
            )}
            tickFormatter={formatPacketLoss}
            CustomTooltip={
              <ChartTooltip title="Loss" formatValue={formatPacketLoss} />
            }
            maxValuebps={100}
            iconColorCard={
              packetLoss?.[packetLoss?.length - 1]?.value > 80
                ? "red"
                : packetLoss?.[packetLoss?.length - 1]?.value > 40
                  ? "orange"
                  : "green"
            }
            handleAplicarZoom={onZoom}
            isZoomEnabled={true}
          />
        </Paper>
      </DialogContent>
    </Dialog>
  );
}
